import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as stApi from '../api/station-tools-api';
import { RootState } from './reducers';
import { Contact } from '../model/types';

export const CONTACTS_GET = 'CONTACTS_GET';
export const CONTACT_ADD = 'CONTACT_ADD';
export const CONTACT_DELETE = 'CONTACT_DELETE';

export const getContacts = (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => async (dispatch, getState) => {
  try {
    const contacts = await stApi.getContacts();
    dispatch({ type: CONTACTS_GET, payload: { contacts } });
  } catch (err) {
    throw err;
  }
};

export const addContact = (data: Partial<Contact>): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => async (dispatch, getState) => {
  try {
    const contact = await stApi.addContact(data);
    dispatch({ type: CONTACT_ADD, payload: { contact } });
  } catch (err) {
    throw err;
  }
};

export const deleteContact = (id: string): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => async (dispatch, getState) => {
  try {
    await stApi.deleteContact(id);
    dispatch({ type: CONTACT_DELETE, payload: { contactId: id } });
  } catch (err) {
    throw err;
  }
};
